export default "__VITE_ASSET__baa51de1__"